// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"55":"error-msg","63":"NotFoundPage"}[chunkId] || chunkId) + "." + {"55":"02adc3aa","63":"496cbf32","453":"6ccdbae9","760":"f4022cde"}[chunkId] + ".chunk.js";
};